import React, { useState } from 'react';

import MainView from './MainView';

import { useQuery } from '../../../hooks/useQuery';
import { SITE_ID } from '../../../config/constants';

/**
 * 사이트 관리
 * @returns
 */
function Main(props) {
  const [popups, setPopups] = useState([]);

  /**
   * API - 목록 조회
   */
  const {
    data,
    // ...restQuery
  } = useQuery(
    '/api/popup/selectPopupList',
    { siteId: SITE_ID },
    {
      cacheTime: 0,
      enabled: !!SITE_ID,
      onSuccess: res => {
        if (res) {
          setPopups(res.result);
        }
      },
    },
  );

  const newProps = {
    ...props,
    popups,
  };

  return <MainView {...newProps} />;
}

export default Main;
